export default __webpack_public_path__ + "static/media/audience-demographics-kids-and-education.png";